export const UPDATE_DRAWER_STATE = 'UPDATE_DRAWER_STATE';
export const APP_DRAWER_TOGGLED = 'APP_DRAWER_TOGGLED';
export const UPDATE_WEEK_DATA = 'UPDATE_WEEK_DATA';
export const UPDATE_EMP_BASIC_PROFILE = 'UPDATE_EMP_BASIC_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const SNACK_BAR = 'SNACK_BAR';
export const SHOW_REGULARIZATION_WINDOW = 'SHOW_REGULARIZATION_WINDOW';
